import { defineRule, configure } from 'vee-validate'
import AllRules from '@vee-validate/rules'

configure({
  // bails: false,
  // validateOnInput: false,
  validateOnChange: false,
  validateOnBlur: false,
  // generateMessage: (context) => {
  //   return `欄位驗證錯誤`
  // },
  // validateOnModelUpdate:false,
})

Object.keys(AllRules).forEach((rule) => {
  defineRule(rule, AllRules[rule])
})

defineRule('required', (value, object) => {
  return value === null || value === undefined || value.length === 0 || !value
    ? object[0]
    : true
})
defineRule('mobile', (value) => {
  const mobileReg = /^(09)[0-9]{8}$/
  if (value.length !== 10) {
    return '請輸入10位數號碼'
  }
  if (!value.match(mobileReg)) {
    return '格式驗證錯誤'
  }
  return true
})

defineRule('companycode', (value, object) => {
  var regexp = /^[0-9]{8}$/
  if (!regexp.test(value)) {
    return object[0]
  }
  return true
})

defineRule('email', (value) => {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true
  }
  // Check if email
  if (!/^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(value)) {
    return '格式驗證錯誤'
  }
  return true
})

function errorFocusInput(errors) {
  const errorKeys = Object.keys(errors)

  const errorElem = errorKeys.map((elem) => {
    const element = document.querySelector(`[name="${elem}"]`)
    if (element && element.getBoundingClientRect) {
      const rect = element.getBoundingClientRect()
      return {
        element,
        top: rect.top,
      }
    }
  })

  errorElem.sort((a, b) => (a.top < b.top ? -1 : 1))

  // const errorElem = document.querySelector(`[name="${firstError}"]`)
  const el = errorElem[0].element
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    })
    el.focus({ preventScroll: true })
  }
}

export { errorFocusInput }
